import React, { useRef, useState } from 'react';
import { Row, Col, Form } from "react-bootstrap"
import { useTranslation } from "react-i18next";
import { ActionButton } from '@fluentui/react/lib/Button';
import { ConstrainMode, DetailsListLayoutMode, OverflowSet, SelectionMode, ShimmeredDetailsList, SpinnerSize, Toggle } from '@fluentui/react';
import { __MessageTypes } from '../../../../common/Dictionaries';
import { base64ToArrayBuffer, isNullUndefined, saveByteArray, showMessage } from '../../../../common/Helpers';
import PropTypes from 'prop-types';
import { __onRenderOverflowButton, __onRenderOverflowItem } from '../../../../common/CommonFuctions';
import { getListContractModificationDocuments, updateContractModificationDocumentDeactivate } from '../../../../services/sKPI/contractModification.service';
import { useGetListContractModificationDocuments } from '../../../../hooks/services/sKPI/useOfContractModification';
import { addTransversalDocument } from '../../../../services/sBook/document.service';
import Loading from '../../../../components/Templates/Site/Loading';
import { FILE_MAX_SIZE } from '../../../../configurations/application.config';
import { getDocumentsDownload } from '../../../../services/sKPI/gap.service';
import { envBlobDocumentUpload, envDeactivateDocument, envDeleteDocument, envDocumentGetUrl, envDocumentValidate } from '../../../../services/Env/transversal.service';

const ContractModificationDocumentBox = (props) => {

    const { 
        inputParam_IsPanelOpen = null,
        inputParam_ObjId = null,
        inputParam_SetMessageConfig = null,
        inputParam_EditMode = false,
        inputParam_DocumentLinkList = [],
        inputParam_SetDocumentLinkList = null,
    } = props;

    const { t } = useTranslation();
    const fileUploadControl = useRef();
    const [uploadInProgress, setUploadInProgress] = useState(false);
    const [deleteDownloadInProgress, setDeleteDownloadInProgress] = useState(false);
    
    const [showDeactivatedDocuments, setShowDeactivatedDocuments] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const [documentLinkListOriginal, setDocumentLinkListOriginal] = useState(null);
    useGetListContractModificationDocuments(inputParam_ObjId, inputParam_DocumentLinkList, inputParam_SetDocumentLinkList, setDocumentLinkListOriginal, inputParam_IsPanelOpen, showDeactivatedDocuments)

    const onUploadFile = async () => {
        //const ojbClientFormData = new FormData();
        //ojbClientFormData.append("file", selectedFile);
        //ojbClientFormData.append("id", inputParam_ObjId);
        //ojbClientFormData.append("url", 'Contract/contractmodificationdocumentadd');
        if (!isNullUndefined(selectedFile)) {
            if (handleFileInput(selectedFile)) {
                showMessage(inputParam_SetMessageConfig, false, __MessageTypes.ERROR, '')
                setUploadInProgress(true);
                await envDocumentGetUrl('Contract/contractmodificationdocumentadd', inputParam_ObjId, selectedFile.name).then(async (responseGetUrl) => {
                    if (responseGetUrl.data.succeeded === true) {
                        await envBlobDocumentUpload(responseGetUrl.data.data.url, responseGetUrl.data.data.fileName, selectedFile).then(async (responseAzure) => {
                            if (responseAzure.data === "" && responseAzure.status === 201) {
                                await envDocumentValidate(responseGetUrl.data.data.document_id).then(async (responseValidate) => {
                                    if (responseValidate.data.succeeded === true) {
                                        if (responseValidate.data.data.result_validate === true) {
                                            showMessage(inputParam_SetMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
                                            inputParam_SetDocumentLinkList && inputParam_SetDocumentLinkList(null);
                                            setSelectedFile(null);
                                            if (fileUploadControl.current) {
                                                fileUploadControl.current.value = '';
                                            }
                                            setUploadInProgress(false);
                                        }
                                        else {
                                            setSelectedFile(null);
                                            showMessage(inputParam_SetMessageConfig, true, __MessageTypes.ERROR, t(responseValidate.data.data.result_validate_msg))
                                            setUploadInProgress(false);
                                        }
                                    }
                                    else {
                                        showMessage(inputParam_SetMessageConfig, true, __MessageTypes.ERROR, t(responseValidate.data.message))
                                        setUploadInProgress(false);
                                    }
                                })
                                .catch((error) => {
                                    showMessage(inputParam_SetMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                                    setUploadInProgress(false);
                                });
                            }
                            else {
                                showMessage(inputParam_SetMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                                setUploadInProgress(false); 
                            }
                        })
                        .catch(async (error) => {
                            await envDocumentValidate(responseGetUrl.data.data.document_id, 0).then(async () => {
                                setSelectedFile(null);
                                showMessage(inputParam_SetMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                                setUploadInProgress(false);
                            })
                            .catch((error) => {
                                setSelectedFile(null);
                                showMessage(inputParam_SetMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                                setUploadInProgress(false);
                            });
                        });
                    } else {
                        showMessage(inputParam_SetMessageConfig, true, __MessageTypes.ERROR, t(responseGetUrl.data.message))
                        setUploadInProgress(false);
                    }
                    setSelectedFile(null);
                    setUploadInProgress(false);
                })
                .catch(() => {
                    showMessage(inputParam_SetMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                    setUploadInProgress(false);
                });
            }
            else {
                showMessage(inputParam_SetMessageConfig, true, __MessageTypes.WARNING, t('data-lang-msg-filesizeerror'))
            }
        }
        else {
            showMessage(inputParam_SetMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-selectfile'))
        }
    };
    
    const onDownloadDocumentsByIds = (documentList, fileName) => {
        setDeleteDownloadInProgress(true);
        getDocumentsDownload(documentList).then((response) => {
            saveByteArray(fileName, base64ToArrayBuffer(response.data.data));
            setDeleteDownloadInProgress(false);
        }).catch((ex) => {
            showMessage(inputParam_SetMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
            setDeleteDownloadInProgress(false);
        });
    }

    const onCancelUpload = () => {
        setSelectedFile(null);
        fileUploadControl.current.value = "";
        showMessage(inputParam_SetMessageConfig, false, __MessageTypes.WARNING, '')
    }

    const handleFileInput = (e) => {
        // handle validations
        const file = !isNullUndefined(e.target) ? e.target.files[0] : e;
        let flag = false;
        if (file) {
            const maxSizeInMB = FILE_MAX_SIZE;
            const maxSizeInBytes = maxSizeInMB * 1024 * 1024;

            if (file.size > maxSizeInBytes) {
                showMessage(inputParam_SetMessageConfig, true, __MessageTypes.WARNING, t('data-lang-msg-filesizeerror'))
                setSelectedFile(file);
            }
            else {
                flag = true;
                setSelectedFile(file);
            }
        }
        return flag;
    };

    const onDeleteDocumentsByIds = (documentId) => {
        setDeleteDownloadInProgress(true);
        
        envDeleteDocument(documentId).then((response) => {
            inputParam_SetDocumentLinkList && inputParam_SetDocumentLinkList(null)
            setDeleteDownloadInProgress(false);
            showMessage(inputParam_SetMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'));
        }).catch(() => {
            setDeleteDownloadInProgress(false);
            showMessage(inputParam_SetMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'));
        });
    }

    const onDeactivateDocumentsByIds = (documentId) => {
        setDeleteDownloadInProgress(true);
        
        envDeactivateDocument(documentId).then((response) => {
            inputParam_SetDocumentLinkList && inputParam_SetDocumentLinkList(null)
            setDeleteDownloadInProgress(false);
            showMessage(inputParam_SetMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'));
        }).catch(() => {
            setDeleteDownloadInProgress(false);
            showMessage(inputParam_SetMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'));
        });
    }



    const onChangeShowDeactivatedDocuments = () => {
        if (!showDeactivatedDocuments) {
            inputParam_SetDocumentLinkList(documentLinkListOriginal)
        }
        else {
            inputParam_SetDocumentLinkList(documentLinkListOriginal.filter(x => x.deactivate === false))
        }

        setShowDeactivatedDocuments(!showDeactivatedDocuments)
    };


    return  <Row className="h-25 py-2 mt-3 border rounded-1">
                <Col xl={12}>
                    <h5 className='border-bottom'>
                    {t('data-lang-lbl-backupdocuments')}
                    </h5>
                </Col>
                <Col xl={12}>
                    <div className='d-flex float-end pb-3'>
                        {
                            inputParam_EditMode &&
                            <>
                                <div className='d-flex align-items-center'>
                                    <Form.Control ref={fileUploadControl} type="file" size="sm" onChange={ handleFileInput } />
                                </div>
                                {
                                    !uploadInProgress &&
                                    <ActionButton id="btnUpload" iconProps={{ iconName: 'Upload' }} onClick={() => onUploadFile()} allowDisabledFocus disabled={selectedFile === null} >
                                        { t('data-lang-btn-upload') }
                                    </ActionButton>
                                }
                                {
                                    !uploadInProgress &&
                                    <ActionButton id="btnUpload" iconProps={{ iconName: 'RemoveFilter' }} onClick={() => onCancelUpload()} allowDisabledFocus disabled={selectedFile === null} >
                                        { t('data-lang-btn-cancel') }
                                    </ActionButton>
                                }
                                {
                                    uploadInProgress &&
                                    <Loading
                                        inputParam_ShowLoading={true}
                                        inputParam_ShowText={false}
                                        inputParam_Width={'35px'}
                                        inputParam_Height={'35px'}
                                        inputParam_Left={""}
                                        inputParam_Style={{marginTop: 0}}
                                        inputParam_ColClassName={"me-2"}
                                        inputParam_MarginLeft={"auto"}
                                        inputParam_SpinnerSize={SpinnerSize.medium} />
                                }
                            </>
                        }
                        <Toggle
                            checked={ showDeactivatedDocuments }
                            className={ "pt-2 float-start" }
                            onChange={ onChangeShowDeactivatedDocuments }
                            role="checkbox"
                            onText={ t('data-lang-lbl-all') }
                            offText={ t('data-lang-lbl-active') }
                            styles={ {root:{float: "right", display: "flex"}, label: {marginRight : "5px"}} }
                        />
                    </div>
                </Col>
                <Col xl={12} className="h-100" style={{minHeight: "150px"}}>
                    <ShimmeredDetailsList
                        className='list-no-filters'
                        enableShimmer={!inputParam_DocumentLinkList}
                        items={inputParam_DocumentLinkList || []}
                        columns={[
                            {
                                key: "documentCode",
                                name: t('data-lang-lbl-code'),
                                fieldName: "documentCode",
                                maxWidth: 100,
                                isResizable: true,
                                onRender:(item, row) => {
                                    return  <div style={{opacity: item.deactivate ? ".5" : "1"}}>
                                                {item.documentCode}
                                            </div>
                                }
                            },
                            {
                                key: "name",
                                name: t('data-lang-lbl-name'),
                                fieldName: "name",
                                maxWidth: 200,
                                isResizable: true,
                                onRender:(item, row) => {
                                    return  <div style={{opacity: item.deactivate ? ".5" : "1"}}>
                                                {item.name}
                                            </div>
                                }
                            },
                            {
                                key: "creationUsername",
                                name: t('data-lang-lbl-creationusername'),
                                fieldName: "creationUsername",
                                maxWidth: 100,
                                isResizable: true,
                                onRender:(item, row) => {
                                    return  <div style={{opacity: item.deactivate ? ".5" : "1"}}>
                                                {item.creationUsername}
                                            </div>
                                }
                            },  
                            {  
                                key: 'id',
                                name: t('data-lang-lbl-actions'),
                                fieldName: 'id',
                                //minWidth: "10%",
                                //maxWidth: "10%",
                                onRender:(item, row) => {
                                    return <div style={{opacity: item.deactivate ? ".5" : "1"}}>
                                            {
                                                deleteDownloadInProgress &&
                                                    <Loading
                                                        inputParam_ShowLoading={true}
                                                        inputParam_ShowText={false}
                                                        inputParam_Width={'25px'}
                                                        inputParam_Height={'25px'}
                                                        inputParam_Left={""}
                                                        inputParam_Style={{marginTop: 0}}
                                                        inputParam_ColClassName={"me-2"}
                                                        inputParam_MarginLeft={"auto"}
                                                        inputParam_SpinnerSize={SpinnerSize.medium} />
                                            }
                                            {
                                                !deleteDownloadInProgress &&
                                                    <OverflowSet
                                                        className="action-menu-list-toolbar d-flex justify-content-center list-menu-action"
                                                        role="menubar"
                                                        items={[
                                                            {
                                                                key: 'download',
                                                                icon: 'CloudDownload',
                                                                name: t('data-lang-btn-download'),
                                                                title: t('data-lang-btn-download'),
                                                                //onClick: () => onDownloadDocumentsByIds(inputParam_ObjId, item.name),
                                                                onClick: () => onDownloadDocumentsByIds([item.id], item.name),

                                                            },
                                                            /*{
                                                                key: 'deactivate',
                                                                icon: 'PageRemove',
                                                                name: t('data-lang-btn-deactivate'),
                                                                title: t('data-lang-btn-deactivate'),
                                                                onClick: () => onDeactivateDocumentsByIds(item.id),
                                                            },*/
                                                            {
                                                                key: 'delete',
                                                                icon: 'Delete',
                                                                name: t('data-lang-btn-delete'),
                                                                title: t('data-lang-btn-delete'),
                                                                onClick: () => onDeleteDocumentsByIds(item.id),
                                                            },
                                                        ].filter(x => inputParam_EditMode === true ? true : x.key !== 'delete')}
                                                        onRenderOverflowButton={__onRenderOverflowButton}
                                                        onRenderItem={__onRenderOverflowItem}
                                                    />
                                            }
                                    </div>
                                }
                            } 
                        ]}
                        getKey={(...args) => (args[0] ? args[0].key : args[1])}
                        setKey="multiple"
                        selectionMode={SelectionMode.none}
                        selectionPreservedOnEmptyClick={true}
                        layoutMode={DetailsListLayoutMode.fixedColumns}
                        constrainMode={ConstrainMode.unconstrained}
                        isHeaderVisible={true}
                        enterModalSelectionOnTouch={true}
                    />
                </Col>
            </Row>
}


ContractModificationDocumentBox.propTypes = {
    inputParam_IsPanelOpen: PropTypes.bool.isRequired,
    inputParam_ObjId: PropTypes.number.isRequired,
    inputParam_SetMessageConfig: PropTypes.func.isRequired,
    inputParam_EditMode: PropTypes.bool.isRequired,

    inputParam_DocumentLinkList: PropTypes.array.isRequired,
    inputParam_SetDocumentLinkList: PropTypes.func.isRequired,
};

export default ContractModificationDocumentBox;